/*
 * Buscador más estricto.
 *
 * La búsqueda de Shopify tolera erratas y manda los agotados al final, así que
 * al escribir "eloria" salían antes piezas como "Eteria" que el Collar Eloria.
 * Este archivo no toca theme.js: envuelve las llamadas a /search/suggest.json
 * para pedir también los agotados y quedarse primero con las piezas que de
 * verdad llevan la palabra escrita. Si ninguna la lleva (p. ej. una errata),
 * se deja el resultado aproximado de Shopify tal cual.
 */
(function () {
  "use strict";

  var STOP_WORDS = ["a", "al", "algo", "alguna", "alguno", "algun", "alli", "and", "con", "como", "cual", "cuales", "de", "del", "donde", "el", "ella", "ellas", "ellos", "en", "es", "esta", "este", "esto", "for", "hay", "i", "la", "las", "le", "les", "lo", "los", "me", "mi", "mis", "necesito", "of", "para", "por", "que", "quiero", "se", "sin", "su", "sus", "the", "to", "tu", "un", "una", "uno", "unos", "unas", "y"];

  function normaliza(texto) {
    return String(texto || "")
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .replace(/<[^>]*>/g, " ")
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  // "collares" -> "collar", "anillos" -> "anillo": la raíz se compara como
  // inicio de palabra, así que también vale mientras se va escribiendo.
  function raiz(palabra) {
    if (palabra.length > 4 && /es$/.test(palabra)) return palabra.slice(0, -2);
    if (palabra.length > 3 && /s$/.test(palabra)) return palabra.slice(0, -1);
    return palabra;
  }

  function terminos(consulta) {
    var vistos = [];
    normaliza(consulta).split(" ").forEach(function (t) {
      if (!t || (t.length < 2 && !/^\d+$/.test(t)) || STOP_WORDS.indexOf(t) !== -1) return;
      var r = raiz(t);
      if (vistos.indexOf(r) === -1) vistos.push(r);
    });
    return vistos;
  }

  function contieneTodos(texto, raices) {
    var conEspacio = " " + normaliza(texto);
    return raices.every(function (r) {
      return conEspacio.indexOf(" " + r) !== -1;
    });
  }

  function ordena(productos, consulta) {
    var raices = terminos(consulta);
    if (!raices.length) return productos;

    var enTitulo = [], enDatos = [], enDescripcion = [];
    productos.forEach(function (p) {
      var datos = [p.title, p.type, (p.tags || []).join(" "), p.vendor].join(" ");
      if (contieneTodos(p.title, raices)) enTitulo.push(p);
      else if (contieneTodos(datos, raices)) enDatos.push(p);
      else if (contieneTodos(datos + " " + p.body, raices)) enDescripcion.push(p);
    });

    var exactos = enTitulo.concat(enDatos, enDescripcion);
    if (!exactos.length) return productos;

    // Dentro de las coincidencias exactas, lo disponible va primero, pero lo
    // agotado sigue apareciendo.
    return exactos.filter(function (p) { return p.available; })
      .concat(exactos.filter(function (p) { return !p.available; }));
  }

  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal !== "function") return;

  window.fetch = function (recurso, opciones) {
    var url;
    try {
      url = new URL(typeof recurso === "string" ? recurso : recurso.url, window.location.origin);
    } catch (e) {
      return fetchOriginal.apply(this, arguments);
    }
    if (!/\/search\/suggest\.json$/.test(url.pathname) || !/product/.test(url.searchParams.get("resources[type]") || "")) {
      return fetchOriginal.apply(this, arguments);
    }

    var consulta = url.searchParams.get("q") || "";
    var limite = Math.max(1, Number(url.searchParams.get("resources[limit]")) || 10);
    url.searchParams.set("resources[limit]", "10");
    url.searchParams.set("resources[options][unavailable_products]", "show");

    return fetchOriginal.call(this, url.pathname + url.search, opciones).then(function (respuesta) {
      if (!respuesta.ok) return respuesta;
      return respuesta.clone().json().then(function (datos) {
        var resultados = datos && datos.resources && datos.resources.results;
        if (resultados && Array.isArray(resultados.products)) {
          resultados.products = ordena(resultados.products, consulta).slice(0, limite);
        }
        return new Response(JSON.stringify(datos), {
          status: respuesta.status,
          headers: { "Content-Type": "application/json" }
        });
      }).catch(function () {
        return respuesta;
      });
    });
  };

  // La página /search también manda los agotados al final; se le pide que los
  // muestre en su sitio, tanto al enviar un buscador como al llegar por un
  // enlace (búsquedas destacadas, historial, enlaces externos).
  var PARAMETROS = { "options[unavailable_products]": "show", "options[prefix]": "last" };

  document.addEventListener("submit", function (evento) {
    var form = evento.target;
    if (!form || !form.getAttribute) return;
    var accion = form.getAttribute("action") || "";
    if (!/\/search\/?$/.test(accion.split("?")[0])) return;
    Object.keys(PARAMETROS).forEach(function (nombre) {
      if (form.querySelector('input[name="' + nombre + '"]')) return;
      var campo = document.createElement("input");
      campo.type = "hidden";
      campo.name = nombre;
      campo.value = PARAMETROS[nombre];
      form.appendChild(campo);
    });
  }, true);

  if (/\/search\/?$/.test(window.location.pathname)) {
    var actual = new URL(window.location.href);
    if (actual.searchParams.get("q") && !actual.searchParams.has("options[unavailable_products]")) {
      Object.keys(PARAMETROS).forEach(function (nombre) {
        if (!actual.searchParams.has(nombre)) actual.searchParams.set(nombre, PARAMETROS[nombre]);
      });
      window.location.replace(actual.pathname + actual.search);
    }
  }
})();
